(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wiljorose-session-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const observedForms = new WeakSet();

    function initialiseSessionForms() {
      document.querySelectorAll('.wiljorose-session-details').forEach((details) => {
        const form = details.closest('form');
        if (!form || observedForms.has(form)) return;
        observedForms.add(form);

        const tidyLegacyDetails = () => {
          form.querySelectorAll('.gpo-element').forEach((field) => {
            const label = field.querySelector('.label-content');
            const input = field.querySelector('input.gpo-input[type="text"]');
            if (
              label?.textContent.trim() === 'Name and date of birth' &&
              input &&
              !input.required &&
              !input.value.trim() &&
              field.querySelectorAll('input:not([type="hidden"]), select, textarea').length === 1
            ) {
              field.hidden = true;
              field.classList.add('wiljorose-legacy-details');
            }
          });
        };

        tidyLegacyDetails();
        const observer = new MutationObserver(tidyLegacyDetails);
        observer.observe(form, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseSessionForms, { once: true });
    } else {
      initialiseSessionForms();
    }
    document.addEventListener('shopify:section:load', initialiseSessionForms);
  })();
  } catch(e) { console.error(e); }
})();

})();
